import _ from 'lodash'
import Popper from 'popper.js'
import jQuery from 'jquery'
import 'bootstrap'
import axios from 'axios'

window._ = _
window.Popper = Popper
window.$ = window.jQuery = jQuery

/**
 * We'll load axios so we can easily issue requests to our Laravel back-end.
 * axios 1.x requires .default for CommonJS interop in some bundlers.
 */
const axiosInstance = axios.default ?? axios
window.axios = axiosInstance

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token',
    )
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by your Laravel application.
 *
 * import Echo from 'laravel-echo'
 * window.Pusher = require('pusher-js');
 * window.Echo = new Echo({
 *     broadcaster: 'pusher',
 *     key: process.env.MIX_PUSHER_APP_KEY,
 *     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
 *     encrypted: true
 * });
 */
